import {AppFlags} from '../../app/app-types';
import OEToolbox from '../../lib/tools/oe-toolbox';
import OELicensingAccessTool from '../../react-oe/oe-licensing-access-tool';

export const OEAlphaBetaProdTypes = {
    alpha:                          'Alpha',
    beta:                           'Beta',
    prod:                           'Production',
    def:                            'Default'
};

//
export class OEVersionTargets {

    constructor(targets, defaultTargets, demoTargets)   {

        this.targetTypes = Object.keys(targets);

        this.targetTypes.forEach(targetType => {
            this[targetType + 'Targets'] = targets[targetType];

            if(defaultTargets && defaultTargets[targetType])    this[targetType + 'Default'] = defaultTargets[targetType];

            if(demoTargets && demoTargets[targetType]) this[targetType + 'Demo'] = demoTargets[targetType];

            this['is' + OEToolbox.capitalize(targetType) + 'Target'] = function(target) {
                return this.chooseTargets(targetType).includes(target);
            }
        });
    }

    targetTypeObjectKey()    {
        return OEAlphaBetaProdTypes.def;
    }

    chooseTargets(targetType)  {
        if(typeof(targetType) === 'string') return this.chooseTargets(this[targetType + 'Targets']);
        
        if(Array.isArray(targetType))   return targetType;
        
        if(typeof(targetType) !== 'object' || !targetType)  return [];

        let key = this.targetTypeObjectKey() || OEAlphaBetaProdTypes.def;

        let res = targetType[key];

        if(!Array.isArray(res)) res = targetType[OEAlphaBetaProdTypes.def];

        return Array.isArray(res) ? res : [];
    }

    targetType(target)    {
        for(let i = 0; i < this.targetTypes.length; ++i) {
            if(this.chooseTargets(this.targetTypes[i]).includes(target))  return this.targetTypes[i];
        }
    }

    targetsForType(targetType)  {
        if(typeof(targetType) !== 'string') return;
        return this.chooseTargets(targetType);
    }

    defaultTargetForType(targetType)   {
        if(typeof(targetType) !== 'string') return;
        let res = this[targetType + 'Default'];

        if(typeof(res) === 'string')    return res;

        if(typeof(res) === 'object' && res)    {
            let key = this.targetTypeObjectKey() || OEAlphaBetaProdTypes.def;
            let res_ = res[key];
            if(typeof(res_) === 'string') return res_;
            res = res[OEAlphaBetaProdTypes.def];
            if(typeof(res) === 'string') return res;
        }
       
        let targets = this.targetsForType(targetType);
        return targets.length ? targets[0] : undefined;

    }

    demoTargetForType(targetType)   {
        if(typeof(targetType) !== 'string') return;
        let res = this[targetType + 'Demo'];

        if(typeof(res) === 'string')    return res;

        if(typeof(res) === 'object' && res)    {
            let key = this.targetTypeObjectKey() || OEAlphaBetaProdTypes.def;
            let res_ = res[key];
            if(typeof(res_) === 'string') return res_;
            res = res[OEAlphaBetaProdTypes.def];
            if(typeof(res) === 'string') return res;
        }
    }

    isDemoTarget(target)    {
        for(let i = 0; i < this.targetTypes.length; ++i) {
            let targetType = this.targetTypes[i];
            if(this.demoTargetForType(targetType) == target) return true;
        }
        return false;
    }
}

//
export class OEVersionFeatureAccess {

    constructor(versionTargets)   {
        this.versionTargets = versionTargets;
    }

    getLicensingAccess(oe)  {
        return OELicensingAccessTool.getLicensingAccess(oe);
    }

    isLicensing()   {
        return this.getLicensingAccess().isLicensing;
    }

    createFeatureAccessObj()  {
        let ret = {};
        this.versionTargets.targetTypes.forEach(type => {
            ret[type + 'Module'] = true;
            ret[type + 'TargetSelection'] = true;
        });
        return ret;
    }

    initialFeatureAccess()    {
        return this.createFeatureAccessObj();
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        return this.initialFeatureAccess();
    }

    getFeatureAccess(isConnected, isLicensing, isValid, edition)    {
        if(typeof(isConnected) !== 'object')    return this.getFeatureAccess(OELicensingAccessTool.pack(isConnected, isLicensing, isValid, edition));
        let licensingAccess = isConnected;
        return this.featureAccessForLicensingAccess(licensingAccess);
    }

    isModuleAvailable(featureAccess, targetType)   {
        if(!targetType) {
            for(let i = 0; i < this.versionTargets.targetTypes.length; ++i) {
                if(this.isModuleAvailable(featureAccess, this.versionTargets.targetTypes[i]))   return true;
            }
            return false;
        }

        return targetType && featureAccess ? (typeof(featureAccess[targetType + 'Module']) === 'boolean' ? featureAccess[targetType + 'Module'] : true) : false;
    }

    isModuleAvailableForLicensingAccess(licensingAccess, targetType)   {
        let featureAccess = this.getFeatureAccess(licensingAccess);
        return this.isModuleAvailable(featureAccess, targetType);
    }

    isTargetSelectionAvailable(featureAccess, targetType)   {
        if(!targetType) {
            for(let i = 0; i < this.versionTargets.targetTypes.length; ++i) {
                if(this.isTargetSelectionAvailable(featureAccess, this.versionTargets.targetTypes[i]))   return true;
            }
            return false;
        }

        return targetType && featureAccess ? (typeof(featureAccess[targetType + 'TargetSelection']) === 'boolean' ? featureAccess[targetType + 'TargetSelection'] : true) : false;
    }

    isTargetSelectionAvailableForTarget(featureAccess, target)   {
        return this.isTargetSelectionAvailable(featureAccess, this.versionTargets.targetType(target));
    }

    isTargetSelectionAvailableForLicensingAccess(licensingAccess, targetType)   {
        let featureAccess = this.getFeatureAccess(licensingAccess);
        return this.isTargetSelectionAvailable(featureAccess, targetType);
    }

    isTargetSelectionAvailableForLicensingAccessTarget(licensingAccess, target)   {
        let featureAccess = this.getFeatureAccess(licensingAccess);
        return this.isTargetSelectionAvailableForTarget(featureAccess, target);
    }

    determineFeatureAccess(oe)  {
        return this.getFeatureAccess(this.getLicensingAccess(oe));
    }

    determineModuleAvailable(oe, targetType)   {
        let featureAccess = this.determineFeatureAccess(oe);
        return this.isModuleAvailable(featureAccess, targetType);
    }

    determineTargetSelectionAvailable(oe, targetType)   {
        let featureAccess = this.determineFeatureAccess(oe);
        return this.isTargetSelectionAvailable(featureAccess, targetType);
    }

    determineTargetSelectionAvailableForTarget(oe, target)   {
        let featureAccess = this.determineFeatureAccess(oe);
        return this.isTargetSelectionAvailableForTarget(featureAccess, target);
    }
}

//
export class OEVersionStartSelectionData {

    constructor(versionTargets, targetTypeContent, targetTypeItems)   {
        this.versionTargets = versionTargets;

        if(Array.isArray(this.versionTargets.targetTypes))  {
            this.versionTargets.targetTypes.forEach(type => {
                if(targetTypeContent && Array.isArray(targetTypeContent[type]))   {
                    this[type] = function() {
                        return [...targetTypeContent[type]];
                    };
                } else if(targetTypeItems && Array.isArray(targetTypeItems[type]))   {
                    this[type] = function() {
                        return [{subcategories: [{items: [...targetTypeItems[type]]}]}];
                    };
                } else {
                    this[type] = function() {
                        return [{subcategories: [{items: []}]}];
                    };
                }
            });
        }

        if(targetTypeContent)    {
            Object.keys(targetTypeContent).forEach(type => {
                if(!this[type])   {
                    if(Array.isArray(targetTypeContent[type]))    {
                        this[type] = function() {
                            return [...targetTypeContent[type]];
                        };
                    } else {
                        this[type] = function() {
                            return [{subcategories: [{items: []}]}];
                        };
                    }
                }
            });
        }
    }

    choose(targetType, ...params)    {
        if(!targetType) return [];
        let fn = this[targetType];
        let ret = typeof(fn) === 'function' ? fn() : [];
        return Array.isArray(ret) ? ret : [];
    }

    chooseWithTarget(target, ...params)    {
        let targetType = this.versionTargets.targetType(target);
        return this.choose(targetType, ...params);
    }

    chooseModules(...params)    {
        return this.choose('modules', ...params)
    }
}

//
export class OEVersionTargetsAlphaBetaProds extends OEVersionTargets    {

    targetTypeObjectKey()    {
        let flags = AppFlags.get();

        if(Array.isArray(flags))   {
            if(flags.includes(AppFlags.production)) return OEAlphaBetaProdTypes.prod;
            if(flags.includes(AppFlags.alpha)) return OEAlphaBetaProdTypes.alpha;
            if(flags.includes(AppFlags.beta)) return OEAlphaBetaProdTypes.beta;
        }

        return OEAlphaBetaProdTypes.def;
    }
}

//
export class OEVersionStartSelectionDataAlphaBetaProd extends OEVersionStartSelectionData {
  
    choose(targetType, flags)    {
        if(!targetType) return [];
        flags = flags || AppFlags.get();

        if(Array.isArray(flags))   {
            let targetType_ = targetType;
            if(flags.includes(AppFlags.production)) {
                targetType_ = targetType_ + OEAlphaBetaProdTypes.prod;
            } else if(flags.includes(AppFlags.alpha)) {
                targetType_ = targetType_ + OEAlphaBetaProdTypes.alpha;
            } else if(flags.includes(AppFlags.beta)) {
                targetType_ = targetType_ + OEAlphaBetaProdTypes.beta;
            } else {
                targetType_ = targetType_ + OEAlphaBetaProdTypes.def;
            }

            if(typeof(this[targetType_]) === 'function')    targetType = targetType_;
        }

        return super.choose(targetType);
    }
}